import {
	getCompanySettingsByCompanyId,
	getCompanySettingsByCompanyIdResolved,
	getCurrentCompanySettings,
	getCurrentCompanySettingsRejected,
	getCurrentCompanySettingsResolved,
	updateCurrentCompanySettings,
	updateCurrentCompanySettingsRejected,
	updateCurrentCompanySettingsResolved,
} from '@Actions';
import { CompanySettings as CompanySettingsType } from '@innovyze/stylovyze';
import { AnyAction, createReducer } from '@reduxjs/toolkit';
import { CompanySettingsStoreState } from '@Types/companySettings.types';

export const defaultCompanySettings: CompanySettingsType = {
	dateFormat: 'DD/MM/YYYY',
	hourCycle12: true,
	timeZoneIANA: 'America/New_York',
	UOM: 'Imperial',
	language: 'en-US',
	simulationServiceLevelDefaultPressureHeadAmount: 50,
	simulationServiceLevelDefaultTimeInMinutes: 30,
	defaultNetworkBoundarySWNELngLat: [],
	defaultImportCoordinateSystemAuthority: 'EPSG',
	defaultImportCoordinateSystemCode: '4326',
	currencyFormatting: {
		currency: 'USD',
		shortCode: 'en-US',
	},
	mapSettings: {
		basemapOrigin: 'mapbox',
		searchRadius: 5,
	},
};

export const initialState: CompanySettingsStoreState = {
	initialized: false,
	status: 'idle',
	companySettings: defaultCompanySettings,
};

interface CompanySettingsReducer {
	[x: string]: (
		state: CompanySettingsStoreState,
		action: AnyAction,
	) => CompanySettingsStoreState | undefined | void;
}

const reducer: CompanySettingsReducer = {
	[getCompanySettingsByCompanyId.toString()]: (state, action) => {
		return {
			...state,
			payload: action.payload,
		};
	},
	[getCompanySettingsByCompanyIdResolved.toString()]: (state, action) => ({
		...state,
		companySettings: {
			...defaultCompanySettings,
			...action.payload.companySettings,
		},
	}),
	[getCurrentCompanySettingsResolved.toString()]: (state, action) => ({
		...state,
		initialized: true,
		companySettings: {
			...defaultCompanySettings,
			...action.payload.companySettings,
		},
	}),
	[getCurrentCompanySettingsRejected.toString()]: state => {
		return { ...state, initialized: true };
	},
	[getCurrentCompanySettings.toString()]: (state, action) => {
		return {
			...state,
			payload: action.payload,
		};
	},
	[updateCurrentCompanySettings.toString()]: state => {
		return { ...state, status: 'pending' };
	},
	[updateCurrentCompanySettingsResolved.toString()]: (state, action) => ({
		...state,
		companySettings: {
			...state.companySettings,
			...(action.payload as Partial<CompanySettingsType>),
		},
		status: 'completed',
	}),
	[updateCurrentCompanySettingsRejected.toString()]: (state, action) => {
		const payload = Object.fromEntries(
			Object.keys(action.payload).map((key: string) => [key, true]),
		);
		return {
			...state,
			companySettingsErrors: {
				...state.companySettingsErrors,
				...payload,
			},
			status: 'rejected',
		};
	},
	[getCurrentCompanySettings.toString()]: (state, action) => {
		return {
			...state,
			payload: action.payload,
		};
	},
};

export default createReducer(initialState, reducer);
